import { FieldPath, UseFormReturn } from "react-hook-form";

import { OptionalLabel } from "@/components/OptionalLabel";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

import { cn } from "@/lib/utils";

export const FormTextInput = <T extends Record<string, unknown>>({
  className,
  fieldName,
  form,
  inputClassName,
  label,
  onBlur,
  onKeyDown,
  optional,
  placeholder,
  sublabel,
}: {
  className?: string;
  fieldName: FieldPath<T>;
  form: UseFormReturn<T>;
  inputClassName?: string;
  label?: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  optional?: boolean;
  placeholder?: string;
  sublabel?: string;
}) => {
  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => {
        return (
          <FormItem className={cn("text-slate-700", className)}>
            {label && (
              <FormLabel className="flex flex-wrap items-center">
                {label}
                {optional && <OptionalLabel className="ml-1.5" />}
                {sublabel && (
                  <FormLabel className="mt-0.5 w-full text-xs text-slate-600">
                    {sublabel}
                  </FormLabel>
                )}
              </FormLabel>
            )}

            <FormControl>
              <Input
                {...field}
                className={cn("text-slate-700", inputClassName)}
                onBlur={(e) => {
                  field.onBlur();
                  onBlur?.(e);
                }}
                onKeyDown={onKeyDown}
                placeholder={placeholder ?? "-"}
                value={field.value as string}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
